import React from 'react'

import { Flex } from 'system'

export const ButtonGroup = props => (
  <Flex flexDirection={['column', 'row']} {...props} />
)
